import React from 'react'
import { IntlProvider } from 'react-intl'
import { MESSAGES_BY_LOCALE } from './messagesByLocale'
import { reportIntlProviderError } from './reportIntlProviderError'
import { DEFAULT_LOCALE, type SupportedLocale } from './types'

type Props = {
  locale: SupportedLocale
  children: React.ReactNode
}

const IntlProviderWithLocale: React.FC<Props> = ({ locale, children }) => {
  return (
    <IntlProvider
      locale={locale}
      defaultLocale={DEFAULT_LOCALE}
      messages={MESSAGES_BY_LOCALE[locale]}
      onError={(err) => reportIntlProviderError(err, locale)}
    >
      {children}
    </IntlProvider>
  )
}

export default IntlProviderWithLocale
